import { remoteConfig } from "@/shared/config/firebase";
import { fetchAndActivate, getBoolean } from "firebase/remote-config";
import { makeAutoObservable, runInAction } from "mobx";

export class FeatureToggleStore {
  isLoaded = false;

  isVoiceConversationEnabled = false;

  constructor() {
    makeAutoObservable(this);
  }

  async load() {
    try {
      await fetchAndActivate(remoteConfig);

      runInAction(() => {
        this.isVoiceConversationEnabled = getBoolean(
          remoteConfig,
          "voice_conversation_enabled"
        );
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoaded = true;
    }
  }
}
